import Module from '@lskjs/module';

export default class BillingProvider extends Module {}
